import React, {  useEffect, useState } from "react";
import "./Login.css";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Regex from "../../service/Regex";
import Loader from "../../Loader/Loader";
import LatestApk from '../../apk/leadx.apk';



const   Login =  () => {
    const history = useHistory();
    const [userId, setUserId] = useState('');
    const [isError, setIserror] = useState('User does not exist.');
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState('hide');
    const [error, setErr] = useState("");

    // If user is logged in automatically redirected to dashboard page
    useEffect(()=> {
        const token = !!localStorage.getItem("token");
        let webView = window.localStorage.webview;
        if(webView !== undefined && webView == 'true') {
            console.log("logout event fired")
            const message = {
                event_name: 'logout_user',
                page:"login"
            }
            const nativeObject = window.ReactNativeWebView;
            if (nativeObject !== undefined) {
                nativeObject.postMessage(JSON.stringify(message));
                window.addEventListener('message', () => {
                    localStorage.clear();
                    window.location.href = '/'
                })
            }
        }
        if(token===true && localStorage.getItem("token") !== 'undefined' && localStorage.getItem("token") !== '')
            history.push('/dashboard');
    },[]);

    //Login function

    const handleSubmit = async (evt) => {
        evt.preventDefault();

        setIsLoading(true)
        if (Regex.email.test(userId)) {
            let myArray = [];
            let is_otp = true;
            let userEmail='';
                if(userId.includes("-")){
                    myArray = userId.split("-");
                    userEmail = myArray[1];
                    is_otp = true;
                }else {
                    userEmail = userId;
                    is_otp = false;

                }

            var config = { headers: { "Content-Type": "application/json"} };
            const base_url = process.env.REACT_APP_API_URL;
            const response  = await axios.post(
                base_url+`/api/v1/generateOTP`,
                {
                    email:  userEmail,
                    is_otp:is_otp,
                    login_type:"Leadx",
                    source: window.localStorage.webview ? "mobile" : "web",
                },
                config,
            );

            if(response?.data?.status === true)
            {
                localStorage.setItem("userId", userId);
                if(response?.data?.response !== undefined ){
                    let loginState = response?.data?.response?.data?.state
                    window.localStorage.user_roles = JSON.stringify(response?.data?.response?.data?.roles)
                    window.localStorage.fusionState = loginState
                    if(loginState){
                        history.push('/login-otp');
                    }else{
                        history.push('/sso-login');
                    }
                }else{
                    setIserror("Unable to generate OTP")
                }
            }
            else
            {
                setShow('show');
                setErr('red');
                setTimeout(() => {
                    setShow('hide');
                }, 3000);
                setIserror(response?.data?.message)
            }
        } else {
            if (userId === '') {
                setIserror('This field is mandatory');
            } else setIserror('Invalid Email ID');
        }
        setIsLoading(false)
    };



    return(
        <>  
          {/*<div className="login">              */}
          {/*      <i className="fa fa-user icon"></i>*/}
          {/*      <input type="text" onChange={(e) => setEmail(e.target.value)} value={email}  placeholder="Username" />*/}
          {/*        <input type="password" onChange={(e) => setPassword(e.target.value)} value={password} placeholder="Password"/>*/}
          {/*        <button onClick={handleLogin} className="btn btn-primary btn-block btn-large">LOGIN</button>   */}
          {/*</div>      */}
          <Loader isLoading={isLoading}/>
          <div className="login-page-bg">
            <div className="wrapper mt-login-35">
                <div className="row justify-content-center">
                    <div className="col-xl-12 col-lg-12 col-md-12">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                <div className="row h-68vh">
                                    <div className="col-lg-6 d-none d-lg-block bg-login-image"></div>
                                    <div className="col-lg-6">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <img className="" src="./img/login_logo.png" alt="" />
                                                <h2 id="blast" className="f-size colorful-text">LeadX</h2>
                                                <h1 className="h4 text-gray-900 mb-4">Welcome Back!</h1>

                                            </div>
                                            <form className="user" onSubmit={handleSubmit}>
                                                <div className="form-group">
                                                    <input type="email" autoComplete="off" className="form-control form-control-user email-input"
                                                           id="exampleInputEmail" aria-describedby="emailHelp" required
                                                           placeholder="Enter Email Address..."
                                                           value={userId}
                                                           onChange={(e) => setUserId(e.target.value.trim())}
                                                    />
                                                </div>


                                                <span className={`otp-error ${show}`}>{isError}</span>
                                                <button type="submit" id=""  className="btn btn-primary btn-user btn-block">
                                                    Next
                                                </button>       
                                            </form>
                                            <br/>
                                            <br/>
                                            <a href={LatestApk} download="leadx.apk">
                                                Download Latest APK
                                            </a>
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
          </div>
        </>
    )
}

export default Login